import React from 'react'
import './style.css'

export const BannerWrapper = (props) => {
    const { children,className } = props
    return(
        <div className="banner">
                <div className={`banner-heading  ${className}`}>
                    {children}
                </div>
            </div>
    )

}